import React from 'react';
import { FlatButton, Dialog, TextField } from 'material-ui';
import autobind from 'react-autobind';
import fire, { handleErrors } from '../util/fire';
import _ from 'lodash';

class PermissionDialog extends React.Component {
	constructor(props) {
		super(props);
		autobind(this);
		this.debouncedUpdateSuggestion = _.debounce(this.updateSuggestion, 500);
		this.state = {
			emailfield: "",
			suggestion: null,
			searching: false
		};
	}

	addPermission() {
		const tripId = this.props.tripId;
		const userToAdd = this.state.suggestion.key;

		fire.database().ref(`owners/${tripId}/${userToAdd}`)
			.set(true)
			.then(() => this.props.hideDialog())
			.catch(handleErrors);
	}

	handleChange(e) {
		this.setState({
			emailfield: e.target.value,
			searching: true
		}, this.debouncedUpdateSuggestion);
	}

	updateSuggestion() {
		this.users = fire.database().ref("users")
			.orderByChild('email')
			.equalTo(this.state.emailfield)
			.once('value')
			.then(resultInfo => {
				if(!resultInfo.exists()) {
					this.setState({ searching: false });
					return;
				}
				const data = resultInfo.val();

				_.forIn(data, (val, key) => {
					this.setState({ suggestion: { ...val, key }, searching: false });
				});
			});
	}

	renderResults() {
		const { searching, suggestion, emailfield }  = this.state;

		if(searching) {
			return (<p>Searching...</p>);
		}

		if(suggestion) {
			return (<p>Found <b>{suggestion.name}</b>, give this person access?</p>);
		} else {
			return (<p>No user found with email {emailfield}</p>);
		}
	}

	render() {
		const actions = [
			<FlatButton
				label="Ok"
				disabled={this.state.suggestion === null}
				primary={true}
				onClick={this.addPermission}
			/>,
			<FlatButton
				label="Cancel"
				primary={false}
				onClick={this.props.hideDialog}
			/>,
		];

		const { emailfield }  = this.state;

		return (
			<Dialog
				title="Give permission to a friend"
				actions={actions}
				modal={false}
				open={true}
				onRequestClose={this.hideDialog}
			>
				<TextField hintText="your.friend@email.com" value={emailfield} floatingLabelText="E-mail of your friend" onChange={this.handleChange}/>
				{this.renderResults()}
			</Dialog>
		);
	}
}

export default PermissionDialog;


// WEBPACK FOOTER //
// ./src/components/PermissionDialog.js